module.exports = __webpack_public_path__ + "img/thumb_26.f01023f7.png";